<template>
    <v-container fluid>
        <v-row class="align-center mb-2">
            <v-col cols="auto">
                <h2 class="text-h6">Tipi disegno</h2>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
                <v-btn color="primary" prepend-icon="mdi-plus" @click="apriDialog(null)">Nuovo tipo disegno</v-btn>
            </v-col>
        </v-row>

        <v-data-table :headers="headers" :items="lista" :items-per-page="15" density="comfortable">
            <template #[`item.parametri`]="{ item }">
                <v-chip size="small" variant="tonal">{{ item.parametri.length }}</v-chip>
            </template>
            <template #[`item.azioni`]="{ item }">
                <v-btn icon variant="text" size="small" @click="apriDialog(item)" title="Modifica">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon variant="text" size="small" color="error" @click="elimina(item)" title="Elimina">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="600" :fullscreen="isMobile">
            <v-card>
                <v-card-title>{{ form.id ? 'Modifica tipo disegno' : 'Nuovo tipo disegno' }}</v-card-title>
                <v-card-text>
                    <v-form ref="formRef">
                        <v-text-field v-model="form.codice" label="Codice" :rules="[v => !!v || 'Obbligatorio']" />
                        <v-text-field v-model="form.descrizione" label="Descrizione (es. Trapezoidale)"
                            :rules="[v => !!v || 'Obbligatorio']" />
                        <v-text-field v-model.number="form.progOrdinamento" type="number" label="Ordine" />
                    </v-form>

                    <template v-if="form.id">
                        <v-divider class="my-4" />
                        <div class="text-caption text-medium-emphasis font-weight-medium mb-2">
                            Parametri geometrici (mostrati nel form posizione quando si sceglie questo tipo disegno)
                        </div>
                        <v-table density="compact">
                            <thead>
                                <tr>
                                    <th>Codice</th>
                                    <th>Etichetta</th>
                                    <th>Ordine</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="p in parametriCorrenti" :key="p.id">
                                    <td>{{ p.codice }}</td>
                                    <td>{{ p.etichetta }}</td>
                                    <td>{{ p.ordine }}</td>
                                    <td class="text-right">
                                        <v-btn icon variant="text" size="x-small" @click="apriDialogParametro(p)">
                                            <v-icon size="18">mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-btn icon variant="text" size="x-small" color="error"
                                            @click="eliminaParametro(p)">
                                            <v-icon size="18">mdi-delete</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                                <tr v-if="parametriCorrenti.length === 0">
                                    <td colspan="4" class="text-center text-medium-emphasis">Nessun parametro</td>
                                </tr>
                            </tbody>
                        </v-table>
                        <v-btn class="mt-2" size="small" variant="tonal" prepend-icon="mdi-plus"
                            @click="apriDialogParametro(null)">Aggiungi parametro</v-btn>
                    </template>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialog = false">Chiudi</v-btn>
                    <v-btn color="primary" :loading="salvando" @click="salva">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogParametro" max-width="420">
            <v-card>
                <v-card-title>{{ formParametro.id ? 'Modifica parametro' : 'Nuovo parametro' }}</v-card-title>
                <v-card-text>
                    <v-form ref="formParametroRef">
                        <v-text-field v-model="formParametro.codice" label="Codice (es. L1, RAGGIO)"
                            :rules="[v => !!v || 'Obbligatorio']" />
                        <v-text-field v-model="formParametro.etichetta" label="Etichetta (es. Base maggiore (mm))"
                            :rules="[v => !!v || 'Obbligatorio']" />
                        <v-text-field v-model.number="formParametro.ordine" type="number" label="Ordine" />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogParametro = false">Annulla</v-btn>
                    <v-btn color="primary" :loading="salvandoParametro" @click="salvaParametro">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: "TipiDisegnoPage",

    data() {
        return {
            dialog: false,
            salvando: false,
            form: this.formVuoto(),
            dialogParametro: false,
            salvandoParametro: false,
            formParametro: this.formParametroVuoto(),
            headers: [
                { title: "Codice", key: "codice" },
                { title: "Descrizione", key: "descrizione" },
                { title: "Ordine", key: "progOrdinamento" },
                { title: "Parametri", key: "parametri", sortable: false },
                { title: "", key: "azioni", sortable: false },
            ],
        };
    },

    computed: {
        isMobile() {
            return this.$vuetify.display.smAndDown;
        },
        lista() {
            return this.$store.getters["tipiDisegno/lista"];
        },
        // Rilegge il tipo disegno corrente dalla lista aggiornata (dopo ogni azione sui
        // parametri lo store ricarica), così la tabella nel dialog resta sincronizzata.
        parametriCorrenti() {
            if (!this.form.id) return [];
            const corrente = this.lista.find(t => t.id === this.form.id);
            return corrente ? corrente.parametri : [];
        },
    },

    mounted() {
        this.$store.dispatch("tipiDisegno/carica");
    },

    methods: {
        formVuoto() {
            return { id: null, codice: "", descrizione: "", progOrdinamento: 0 };
        },

        apriDialog(item) {
            this.form = item
                ? { id: item.id, codice: item.codice, descrizione: item.descrizione, progOrdinamento: item.progOrdinamento }
                : this.formVuoto();
            this.dialog = true;
        },

        async salva() {
            if (!this.$refs.formRef.validate()) return;
            this.salvando = true;
            try {
                const { id, ...dati } = this.form;
                if (id) {
                    await this.$store.dispatch("tipiDisegno/aggiorna", { id, dati });
                } else {
                    const resp = await this.$store.dispatch("tipiDisegno/crea", dati);
                    // Resta nel dialog per poter subito aggiungere i parametri.
                    this.form.id = resp.data.id;
                }
            } catch (error) {
                console.log(error);
            }
            this.salvando = false;
        },

        async elimina(item) {
            try {
                await this.$store.dispatch("tipiDisegno/elimina", item.id);
            } catch (error) {
                console.log(error);
            }
        },

        formParametroVuoto() {
            return { id: null, codice: "", etichetta: "", ordine: 0 };
        },

        apriDialogParametro(p) {
            this.formParametro = p ? { ...p } : this.formParametroVuoto();
            this.dialogParametro = true;
        },

        async salvaParametro() {
            if (!this.$refs.formParametroRef.validate()) return;
            this.salvandoParametro = true;
            try {
                const { id, ...dati } = this.formParametro;
                if (id) {
                    await this.$store.dispatch("tipiDisegno/aggiornaParametro", { tipoDisegnoId: this.form.id, id, dati });
                } else {
                    await this.$store.dispatch("tipiDisegno/creaParametro", { tipoDisegnoId: this.form.id, dati });
                }
                this.dialogParametro = false;
            } catch (error) {
                console.log(error);
            }
            this.salvandoParametro = false;
        },

        async eliminaParametro(p) {
            try {
                await this.$store.dispatch("tipiDisegno/eliminaParametro", { tipoDisegnoId: this.form.id, id: p.id });
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
